import axios from 'axios';
import { APIAddress } from 'constants/config';
import Joi from 'joi-browser';
import parseLog from 'util/parseLog';
import queryString from 'query-string';

/**
* GET
* Return school operation logs.
**/
export const schema = Joi.object().keys({
  school_teacher: Joi.number().integer().allow(null),
  start_date: Joi.string().allow(''),
  end_date: Joi.string().allow(''),
  amount_per_page: Joi.number().integer().allow(null),
  current_page_number: Joi.number().integer().allow(null)
});

export default function getSchoolLog(schoolID, params) {

  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }
  let query = queryString.stringify(params);
  return new Promise((resolve, reject)=>{
    axios.put(APIAddress, {
      'uri': `/log/${schoolID}/?${query}`, 
      'method': 'GET', 
      'token': localStorage.getItem('token'),
    })
      .then((res)=>{
        const logs = parseLog(res.data);
        resolve(logs);
      })
      .catch((err)=>{
        reject(err);
      });
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/school/getSchoolLog.js